import React, { useMemo, useState } from "react"
import { Button, Popover, Typography } from "@material-ui/core"
import {
  getFileUploadLinkFromDB,
  getImageUploadLinkFromDB,
} from "utils/text-utils"
import { Image, PictureAsPdf } from "@material-ui/icons"

export default function useAttachmentPopOver() {
  const [attachment, setAttachment] = useState("")
  const [anchorEl, setAnchorEl] = useState(null)
  const [open, setOpen] = useState(false)

  const isAttachmentImg = useMemo(() => {
    if (!attachment) return false

    return ["jpg", "png", "jpeg"].includes(attachment.split(".").slice(-1))
  }, [attachment])

  const CustomPopOver = () => {
    return (
      <Popover
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        onClose={() => {
          setOpen(false)
          setAnchorEl(null)
        }}
        disableRestoreFocus
      >
        <div style={{ padding: "8px" }}>
          <Typography>Attachment</Typography>
          {attachment && isAttachmentImg ? (
            <img
              alt=""
              src={getImageUploadLinkFromDB(attachment)}
              style={{ height: 480, width: "auto" }}
            />
          ) : null}
          {attachment && !isAttachmentImg ? (
            <embed
              src={getFileUploadLinkFromDB(attachment)}
              type="application/pdf"
              width={640}
              height={480}
            />
          ) : null}
        </div>
      </Popover>
    )
  }

  // eslint-disable-next-line react/prop-types
  const CustomButton = ({ image = "", onClick }) => {
    if (!image) return null

    const isImg = image.split(".").slice(-1) !== "pdf"
    return (
      <Button
        onClick={(e) => {
          e.stopPropagation()
          if (onClick) {
            onClick()
            return
          }
          setAnchorEl(e.currentTarget)
          setAttachment(image)
          setOpen(true)
        }}
      >
        {isImg ? <Image /> : <PictureAsPdf />}
      </Button>
    )
  }

  return {
    Popover: CustomPopOver,
    Button: CustomButton,
  }
}
